import { render, staticRenderFns } from "./stadium_type_setting.vue?vue&type=template&id=46014966&"
import script from "./stadium_type_setting.vue?vue&type=script&lang=ts&"
export * from "./stadium_type_setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports